import crudHandlers from './_crud'

export default (state, action) => {
	const { type } = action
	switch (type) {
		case 'LOAD_INSPECTION_SUBCATEGORY':
			return {
				...state,
				entities: action.payload,
			}
		default:
			state = crudHandlers(state, action, 'inspection_subcategory')

			return state
	}
}
